module.exports = __webpack_public_path__ + "img/gold.b7599c4f.svg";